/* ============================================================
   MAIN — boot, scroll storytelling, content injection.
   Real series + contact data taken from madhukunj.com.
   Swap-in points are marked SWAP for product imagery / logo.
============================================================= */
(function () {
  const O = window.Ornaments;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isTouch = window.matchMedia('(hover: none)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---- Confirmed series (madhukunj.com). Curated for the demo;
          full set surfaces behind "View all 13 series". ---------- */
  const SERIES = [
    { name: 'Gold Series',     mood: 'Warm · woody · sacred',     note: 'The flagship. Deep, resinous, made for the morning lamp.', from: '₹60', img: 'assets/img/gold-400.png' },
    { name: 'Nature Series',   mood: 'Green · cooling · fresh',    note: 'Forest florals for an unhurried, open-window calm.',        from: '₹45', img: 'assets/img/nature-series.png' },
    { name: 'Platinum Series', mood: 'Soft · powdery · refined',   note: 'A quiet luxury — fragrance that lingers, never shouts.',     from: '₹90', img: 'assets/img/platinum-series.png' },
    { name: 'Premium Series',  mood: 'Rich · floral · festive',    note: 'For the days that ask for celebration and abundance.',       from: '₹75', img: 'assets/img/premium-series.png' },
    { name: 'Urja Dhoop',      mood: 'Earthy · grounding · still', note: 'Bambooless dhoop. Dense smoke for deep meditation.',         from: '₹40', img: 'assets/img/urja-dhoop.png' },
    { name: 'Pure Camphor',    mood: 'Crisp · cooling · clean',    note: 'The purest note of the aarti — bright and ceremonial.',      from: '₹55', img: 'assets/img/pure-camphor.png' },
  ];

  const TESTIMONIALS = [
    { q: 'Woods has a truly mesmerizing, soothing fragrance — I used it for my meditation and the experience was wonderful. The pineapple is fruity and awesome.', name: 'Punam', role: 'Verified Buyer' },
    { q: 'The product is really good with a lovely fragrance. I would definitely order it again — I especially love the zip-lock packing that keeps the scent intact.', name: 'Sandeep', role: 'Verified Buyer' },
    { q: 'The most important thing is that it is a product of Odisha, and it can stand comparison with any of the big brands.', name: 'Siba Prasad Nath', role: 'Verified Buyer' },
    { q: 'The fragrance of the cups is really good — the guggul and other herbal notes come through very clearly.', name: 'Gautam Gill', role: 'Verified Buyer' },
    { q: 'Super smell and pure notes — the natural loban and sambrani feel fresh and energetic, making the atmosphere calm and religious.', name: 'Verified Buyer', role: 'Madhukunj Customer' },
    { q: 'Pineapple and Festival notes are strong and soothing; Woods is a milder note that is best for my meditation and yoga time.', name: 'Verified Buyer', role: 'Madhukunj Customer' },
    { q: 'Wonderful product. Really good whenever we do yoga or pooja — my whole family loved it.', name: 'Verified Buyer', role: 'Madhukunj Customer' },
    { q: 'Wonderful, heavenly fragrance — and great value for money too.', name: 'Debjani B.', role: 'Verified Buyer' },
    { q: 'We lit two pineapple sticks in our puja room and my sister thought a real pineapple was ripening — it smells exactly like fresh pineapple!', name: 'Verified Buyer', role: 'Madhukunj Customer' },
    { q: 'Excellent product — dil khush ho gaya!', name: 'Sastipada Dutta', role: 'Verified Buyer' },
    { q: 'The smells are awesome and the sticks are nice and long.', name: 'Debashis Roy', role: 'Verified Buyer' },
    { q: 'A good product, and the price is very good too. Genuinely value for money.', name: 'Priya', role: 'Verified Buyer' },
    { q: 'Fantastic and genuine product — thank you so much.', name: 'Moumita', role: 'Verified Buyer' },
    { q: 'Highly fragrant sticks — loved the scents.', name: 'Verified Buyer', role: 'Madhukunj Customer' },
  ];

  /* =========================================================
     BUILD ORNAMENTS
  ========================================================= */
  function paintOrnaments() {
    const paint = (sel, svg) => { const el = $(sel); if (el) el.innerHTML = svg; };
    paint('#loaderWheel', O.konarkWheel());
    paint('#heroWheel', O.konarkWheel({ width: 1.1 }));
    paint('#navWheel', O.konarkWheel({ width: 2 }));
    paint('#footWheel', O.konarkWheel({ width: 1.4 }));
    paint('#heritageSpire', O.kalingaSpire());
    paint('#heroRing', O.templeRing());
    paint('#heroSkyline', O.templeSkyline());
    paint('#heroPillarL', O.konarkPillar());
    paint('#heroPillarR', O.konarkPillar());
    $$('.col-pillar').forEach((el) => { el.innerHTML = O.konarkPillar(); });
    $$('.border-pattichitra').forEach((el) => (el.innerHTML = O.pattachitraBorder()));
  }

  /* =========================================================
     SERIES CARDS — offset, art-directed, not a flat grid
  ========================================================= */
  /* ---- Curated collections (the approved 7, shown as circles) ---- */
  const COLLECTIONS = [
    { key: 'nature',   name: 'Nature',            sub: 'Collection', desc: 'Forest florals and fresh greens for an open, unhurried, window-cracked calm.' },
    { key: 'devotion', name: 'Devotion & Divine', sub: 'Collection', desc: 'Warm, resinous and sacred — shaped for the morning lamp and the evening aarti.' },
    { key: 'urja',     name: 'Urja Aromatherapy', sub: 'Collection', desc: 'Earthy, grounding dhoop with dense, slow smoke — made for deep meditation.' },
    { key: 'royal',    name: 'Royal',             sub: 'Collection', desc: 'Rich, opulent fragrance for festivals, gifting and days that call for abundance.' },
    { key: 'modern',   name: 'Modern',            sub: 'Collection', desc: 'Clean, contemporary notes for the everyday modern home — fresh and effortless.' },
    { key: 'ritual',   name: 'Ritual Essentials', sub: '',           desc: 'Pure camphor, dhoop and the bright, ceremonial essentials every puja needs.' },
    { key: 'everyday', name: 'The Everyday',      sub: 'Collection', desc: 'The trusted daily fragrance — calm, comforting and always reliable.' },
  ];

  function buildCollections() {
    const wrap = $('#circles');
    if (!wrap) return;
    const rows = [[0, 1], [2, 3, 4], [5, 6]];   // 2-3-2 formation
    wrap.innerHTML = rows.map((idxs) =>
      `<div class="circ-row">` + idxs.map((i) => {
        const c = COLLECTIONS[i];
        return `<a class="circ" href="#collections" data-slot="collection" data-key="${c.key}">
          <div class="circ__media">
            ${c.img ? `<img class="circ__img" src="${c.img}" alt="${c.name}" loading="lazy" />`
                    : `<span class="circ__seal">${O.lotus()}</span>`}
          </div>
          <span class="circ__label"><span class="circ__name">${c.name}</span>${c.sub ? `<span class="circ__sub">${c.sub}</span>` : ''}</span>
        </a>`;
      }).join('') + `</div>`
    ).join('');
  }

  /* ---- Find Your Scent: map answers → a recommended collection ---- */
  function recommend(occasion, feeling) {
    let key = { puja: 'devotion', festival: 'royal', meditation: 'urja', gifting: 'royal', everyday: 'everyday' }[occasion] || 'everyday';
    const feel = { floral: 'nature', woody: 'royal', sacred: 'devotion', fresh: 'nature' };
    if (occasion === 'everyday' || occasion === 'gifting') key = feel[feeling] || key;
    if (occasion === 'meditation') key = 'urja';
    if (feeling === 'fresh' && occasion === 'puja') key = 'ritual';
    if (feeling === 'floral' && occasion === 'everyday') key = 'nature';
    return COLLECTIONS.find((c) => c.key === key) || COLLECTIONS[0];
  }

  function initFinder() {
    const stage = $('#finderStage'), result = $('#finderResult'), submit = $('#finderSubmit');
    if (!stage || !result) return;
    const picks = {};
    $$('.finder__opts button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const group = btn.parentElement.dataset.group;
        btn.parentElement.querySelectorAll('button').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        picks[group] = btn.dataset.val;
      });
    });
    submit.addEventListener('click', () => {
      if (!picks.occasion || !picks.feeling) {
        submit.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 280 });
        submit.textContent = 'Pick one from each ↑';
        setTimeout(() => { submit.textContent = 'Reveal My Scent'; }, 1600);
        return;
      }
      const c = recommend(picks.occasion, picks.feeling);
      result.innerHTML = `
        <span class="eyebrow">Your fragrance</span>
        <h3>${c.name}${c.sub ? ` <em>${c.sub}</em>` : ''}</h3>
        <p>${c.desc}</p>
        <a href="#collections" class="btn btn--line">Explore this collection →</a>
        <span class="finder__again" id="finderAgain">↺ Start over</span>`;
      stage.hidden = true; result.hidden = false;
      if (window.gsap) gsap.fromTo(result, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: .6, ease: 'power2.out' });
      $('#finderAgain').addEventListener('click', () => {
        result.hidden = true; stage.hidden = false;
        $$('.finder__opts button').forEach((b) => b.classList.remove('is-active'));
        delete picks.occasion; delete picks.feeling;
      });
    });
  }

  function buildSeries() {
    const stack = $('#seriesStack');
    if (!stack) return;
    stack.innerHTML = SERIES.map((s) => `
      <article class="scard" data-reveal>
        <div class="scard__media" data-slot="product">
          ${s.img
            ? `<img class="scard__img" src="${s.img}" alt="${s.name}" loading="lazy" />`
            : `<div class="slot"><span class="slot__seal">${O.lotus()}</span></div>`}
        </div>
        <h3 class="scard__name">${s.name}</h3>
        <p class="scard__meta">${s.mood} · from ${s.from}</p>
      </article>`).join('');
  }

  // Prefer editor-managed reviews (JSON emitted by mk-testimonials.liquid);
  // fall back to the built-in list if none are set.
  function getTestimonials() {
    const el = document.getElementById('testiData');
    if (el) {
      try { const d = JSON.parse(el.textContent); if (Array.isArray(d) && d.length) return d; }
      catch (e) { /* fall through */ }
    }
    return TESTIMONIALS;
  }

  function buildTestimonials() {
    const container = $('#testiInner');
    if (!container) return;
    const DATA = getTestimonials();
    const COLS = 5;
    const speeds = ['36s','30s','34s','28s','32s'];
    for (let c = 0; c < COLS; c++) {
      const dir = c % 2 === 0 ? 'up' : 'down';
      const col = document.createElement('div');
      col.className = `testi__col testi__col--${dir}`;
      col.style.setProperty('--dur', speeds[c]);
      // distribute testimonials across columns, then duplicate for seamless loop
      const colCards = DATA.filter((_, i) => i % COLS === c);
      const allCards = [...colCards, ...colCards]; // duplicate for seamless loop
      col.innerHTML = allCards.map((t, i) => {
        const variant = (i + c) % 2 === 0 ? 'white' : 'lgold';
        return `<div class="tcard tcard--${variant}">
          <span class="tcard__marks">“</span>
          <p class="tcard__quote">${t.q}</p>
          <span class="tcard__name">${t.name}</span>
          <span class="tcard__role">${t.role}</span>
        </div>`;
      }).join('');
      container.appendChild(col);
    }
  }

  /* =========================================================
     CUSTOM CURSOR
  ========================================================= */
  function initCursor() {
    const dot = $('.cursor__dot'), ring = $('.cursor__ring');
    if (!dot || !ring) return;   // custom cursor removed → native cursor
    let mx = innerWidth / 2, my = innerHeight / 2, rx = mx, ry = my;
    addEventListener('mousemove', (e) => {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = `translate(${mx}px,${my}px)`;
    });
    (function loop() {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      ring.style.transform = `translate(${rx}px,${ry}px)`;
      requestAnimationFrame(loop);
    })();
    $$('a, button, .chip, .scard, .path').forEach((el) => {
      el.addEventListener('mouseenter', () => document.body.classList.add('cursor-hot'));
      el.addEventListener('mouseleave', () => document.body.classList.remove('cursor-hot'));
    });
  }

  /* =========================================================
     LOADER → then unveil hero word from smoke
  ========================================================= */
  function runLoader() {
    const loader = $('#loader');
    if (!loader) return;
    const bar = $('.loader__bar span');
    const done = () => {
      window.scrollTo(0, 0);
      document.body.classList.remove('is-loading');
      loader.classList.add('is-out');
      setTimeout(() => loader.remove(), 900);
      // recalc triggers now the page is unlocked, then pin to the top
      if (window.ScrollTrigger) ScrollTrigger.refresh();
      window.scrollTo(0, 0);
      revealHero();
    };
    // returning visitor — skip the loader AND the reveal animation; snap hero to final state
    if (window.__mkSeenLoader) {
      document.body.classList.remove('is-loading');
      loader.remove();
      const word = $('#heroWord');
      if (word) { word.style.filter = 'none'; word.style.opacity = '1'; word.style.letterSpacing = '0.02em'; }
      ['.hero__line1', '.hero__line2', '.hero__line2b', '.hero__line3', '.hero__eyebrow', '.hero__tagline', '.hero__cta'].forEach((s) => { const e = $(s); if (e) e.style.opacity = '1'; });
      const sc = $('.hero__scroll'); if (sc) sc.style.opacity = '0.8';
      if (window.ScrollTrigger) ScrollTrigger.refresh();
      return;
    }
    if (reduceMotion) { bar.style.width = '100%'; setTimeout(done, 300); return; }
    // animate progress bar then leave
    let p = 0;
    const tick = () => {
      p += Math.random() * 16;
      bar.style.width = Math.min(p, 100) + '%';
      if (p < 100) setTimeout(tick, 120);
      else setTimeout(done, 500);
    };
    setTimeout(tick, 350);
  }

  /* Dissolve the wordmark out of the smoke by animating the
     SVG displacement + blur down to zero. */
  function revealHero() {
    const word = $('#heroWord');
    const disp = $('#smokeDisp');
    const blur = $('#smokeBlur');
    const line1 = $('.hero__line1');
    const line2 = $('.hero__line2');
    const line2b = $('.hero__line2b');
    const line3 = $('.hero__line3');
    const eyebrow = $('.hero__eyebrow');
    const tagline = $('.hero__tagline');
    const cta = $('.hero__cta');
    const scroll = $('.hero__scroll');

    if (!window.gsap || reduceMotion) {
      word.style.filter = 'none'; word.style.opacity = 1;
      [line1, line2, line2b, line3, eyebrow, tagline, cta, scroll].forEach((el) => el && (el.style.opacity = 1));
      return;
    }
    const tl = gsap.timeline();
    tl.to(word, { opacity: 1, duration: 2.4, ease: 'power2.out' }, 0)
      .to(disp, { attr: { scale: 0 }, duration: 2.8, ease: 'power3.out' }, 0)
      .to(blur, { attr: { stdDeviation: 0 }, duration: 2.6, ease: 'power3.out' }, 0)
      .fromTo(word, { letterSpacing: '0.18em', y: 14 }, { letterSpacing: '0.02em', y: 0, duration: 2.6, ease: 'power3.out' }, 0)
      .fromTo(line1, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 1 }, 1.6)
      .fromTo(line2, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 1 }, 1.8)
      .fromTo(line2b, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 1 }, 1.9)
      .fromTo(line3, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 1 }, 2.0)
      .fromTo(eyebrow, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 1 }, 2.2)
      .fromTo(tagline, { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 1.1 }, 2.4)
      .fromTo(cta, { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 1 }, 2.7)
      .fromTo(scroll, { opacity: 0 }, { opacity: 0.8, duration: 0.8 }, 3.0)
      /* the smoke filter is fully zeroed out by now (scale/blur = 0) and does
         nothing visually, but stays ATTACHED — its region still clips
         descenders (the "j" in Madhukunj) against a hard edge. Drop the
         filter entirely once settled so nothing is clipping the glyphs. */
      .set(word, { filter: 'none' }, 3.0);
  }

  /* =========================================================
     SCROLL STORYTELLING
  ========================================================= */
  function initScroll() {
    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);

    // hero parallax: content drifts up & fades as you scroll past.
    // immediateRender:false so this never clobbers the smoke-reveal at scroll 0.
    gsap.to('.hero__content', {
      yPercent: -28, opacity: 0, ease: 'none', immediateRender: false,
      scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom top', scrub: 1 },
    });
    gsap.to('#heroWheel', {
      rotate: 90, scale: 1.25, ease: 'none',
      scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom top', scrub: 1.4 },
    });

    if (!reduceMotion) {
      // continuous slow turn of the chariot wheel
      gsap.to('#heroWheel .orn--wheel', { rotate: 360, duration: 120, repeat: -1, ease: 'none', transformOrigin: '50% 50%' });
    }

    // generic reveals
    $$('[data-reveal]').forEach((el) => {
      gsap.fromTo(el, { opacity: 0, y: 40 }, {
        opacity: 1, y: 0, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 86%' },
      });
    });

    // split display headings — lines rise independently
    $$('.display').forEach((h) => {
      const spans = $$('span', h);
      if (!spans.length) return;
      gsap.fromTo(spans, { yPercent: 120, opacity: 0 }, {
        yPercent: 0, opacity: 1, duration: 1.1, ease: 'power4.out', stagger: 0.12,
        scrollTrigger: { trigger: h, start: 'top 85%' },
      });
    });

    // pattachitra borders draw themselves in
    $$('.border-pattichitra').forEach((b) => {
      gsap.fromTo(b, { clipPath: 'inset(0 100% 0 0)' }, {
        clipPath: 'inset(0 0% 0 0)', duration: 1.6, ease: 'power2.inOut',
        scrollTrigger: { trigger: b, start: 'top 90%' },
      });
    });

    // kalinga spire rises from its base
    gsap.fromTo('#heritageSpire', { yPercent: 12, opacity: 0 }, {
      yPercent: 0, opacity: 0.22, duration: 1.6, ease: 'power3.out',
      scrollTrigger: { trigger: '#heritage', start: 'top 70%' },
    });

    // count-up stats (heritage + recognized sections)
    $$('[data-count]').forEach((el) => {
      const target = +el.dataset.count, suffix = el.dataset.suffix || '';
      const fmt = el.dataset.format;
      const o = { v: 0 };
      gsap.to(o, {
        v: target, duration: 1.8, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 88%' },
        onUpdate: () => {
          const n = Math.round(o.v);
          el.textContent = fmt === 'indian'
            ? n.toLocaleString('en-IN') + suffix
            : n.toLocaleString() + suffix;
        },
      });
    });

    // nav solidifies after hero
    ScrollTrigger.create({
      start: 'top -80', toggleClass: { targets: '#nav', className: 'nav--solid' },
    });
  }

  /* =========================================================
     NAV (mobile)
  ========================================================= */
  function initNav() {
    const burger = $('#navBurger'), links = $('#navLinks');
    burger.addEventListener('click', () => {
      const open = document.body.classList.toggle('nav-open');
      burger.classList.toggle('is-x', open);
    });
    $$('#navLinks a').forEach((a) => a.addEventListener('click', () => {
      document.body.classList.remove('nav-open'); burger.classList.remove('is-x');
    }));
  }

  /* =========================================================
     SMOKE
  ========================================================= */
  function initSmoke() {
    // Canvas smoke was used for the closing section (now removed). No-op.
  }

  // Two smoke columns alternate — one at a time. Uses GSAP so fades are
  // reliable even when the tab loses focus or timers drift.
  function initSmokeSides() {
    const right = $('.hero__smoke-video--right');
    const left  = $('.hero__smoke-video--left');
    if (!right || !left || !window.gsap) return;
    // phones skip the smoke video: it is a 1.8 MB download
    if (window.matchMedia && window.matchMedia('(max-width: 760px)').matches) return;

    const PEAK = 0.50;
    const IN   = 2.6;    // seconds
    const HOLD = 5.2;
    const OUT  = 4.4;

    // hard-reset both to invisible, paused
    gsap.set([left, right], { opacity: 0 });
    [left, right].forEach((v) => { try { v.pause(); } catch (e) {} });

    // videos are preload="none" so they don't compete with first paint
    if (reduceMotion) { right.preload = 'auto'; right.load(); gsap.set(right, { opacity: PEAK }); return; }

    const sides = [right, left];
    let idx = 0;

    function run() {
      const active  = sides[idx % 2];
      const dormant = sides[(idx + 1) % 2];
      idx++;

      // hard-kill the dormant side immediately so it can never stay visible
      gsap.killTweensOf(dormant);
      gsap.set(dormant, { opacity: 0 });
      try { dormant.pause(); } catch (e) {}

      // reset active to bottom of clip then play
      try { active.currentTime = 0; } catch (e) {}
      const p = active.play(); if (p && p.catch) p.catch(() => {});

      // fade in → hold → fade out → next side
      gsap.timeline()
        .to(active, { opacity: PEAK, duration: IN, ease: 'power2.out' })
        .to(active, { opacity: PEAK, duration: HOLD })
        .to(active, { opacity: 0, duration: OUT, ease: 'power1.in',
            onComplete: () => { try { active.pause(); } catch (e) {} run(); }
          });
    }

    run();
  }

  /* =========================================================
     BOOT
  ========================================================= */
  // run each step in isolation so one failure can never halt the rest
  const safe = (fn) => { try { fn(); } catch (e) { console.warn('[madhukunj]', e); } };

  // hard failsafe: no matter what, never leave the page stuck on the loader
  function forceReveal() {
    if (!document.body.classList.contains('is-loading')) return;
    document.body.classList.remove('is-loading');
    const ld = document.getElementById('loader');
    if (ld) { ld.classList.add('is-out'); setTimeout(() => ld.remove(), 800); }
    const w = $('#heroWord'); if (w) { w.style.opacity = '1'; w.style.filter = 'none'; }
    ['.hero__line1', '.hero__line2', '.hero__line2b', '.hero__line3', '.hero__eyebrow', '.hero__tagline', '.hero__cta', '.hero__scroll'].forEach((s) => { const e = $(s); if (e) e.style.opacity = '1'; });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
    safe(() => { $('#year').textContent = new Date().getFullYear(); });
    safe(paintOrnaments);
    safe(buildCollections);
    safe(initFinder);
    safe(buildTestimonials);
    safe(initCursor);
    safe(initNav);
    safe(initSmoke);
    safe(initSmokeSides);
    safe(initScroll);
    safe(runLoader);
    // backstop in case runLoader itself never finishes
    setTimeout(forceReveal, 5000);
  });
})();
